import React, { Component } from 'react';
import '../myutils';
import { AppBarMobile, withDataProvider, translate } from 'react-admin';
import { Redirect } from 'react-router';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import Stats from './Stats';
import {configAPI} from '../config'
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment'; //'../res/jssip';

const styles = {
    welcome: { marginBottom: '2em' },
    flex: { display: 'flex' },
    leftCol: { flex: 1, marginRight: '1em'},
    rightCol: { flex: 1, marginLeft: '1em', maxWidth: '50%' , padding: '0em 1em'},
    singleCol: { marginTop: '1em' },
    cardStyle0: {
        width: '100%',
        display: 'inline-block',
        verticalAlign: 'top'},
    cardStyle1: {
            width: '50%',
            display: 'inline-box',
            verticalAlign: 'top',
            padding: ''}            
};

class Statistics extends Component {
    componentDidMount() {
        const ReqGetSession = new Request(configAPI.api.prod+'GetSession?token='+sessionStorage.B.encodeDecode());
        fetch(ReqGetSession)
            .then(response => response.json())
            .then(session => {
                if (session.responseStatus==='OK') {
                    this.setState({units: Number((session.units).toFixed(1))});
                    this.setState({userID: session.username});
                    this.setState({unitsExpireDate: session.unitsExpireDate});
                    sessionStorage.setItem('userDID', session.username)
                } else return (<Redirect to="/route/to/redirect" />);
                const ReqGetTransactions = new Request(configAPI.api.prod+'GetTransactions?token='+sessionStorage.B.encodeDecode());
                return fetch(ReqGetTransactions)
                .then(response => { return response.json();})
                .then(trans => {
                    if (trans.responseStatus==='OK'){
                        let transactions=trans.transactions;
                        this.setState({transactions: transactions})
                        let myseries = [0,0,0,0,0];
                        let totalAmount = 0;
                        let totalUseThisMonth = 0;
                        let totalPurchaseThisMonth = 0;
                        var thisMonth = moment().format('YYYY-MM');
                        transactions.forEach(trn => {
                            if  (trn.description.includes("SMS")) myseries[0]-=parseInt(trn.amount);
                            else if  (trn.description.includes("Start-")) myseries[1]-=parseInt(trn.amount);
                            else if  (trn.description.includes("transfer to")) myseries[2]-=parseInt(trn.amount);
                            else if  (trn.description.includes("Units expired")) myseries[3]-=parseInt(trn.amount);
                            else if (trn.amount<0) myseries[4]-=parseInt(trn.amount);
                            if (trn.transactionTime.includes(thisMonth)){
                                if (trn.amount<0) {
                                    totalUseThisMonth-=parseInt(trn.amount);
                                }
                                else {
                                    totalPurchaseThisMonth+=parseInt(trn.amount);
                                } 
                            } 
                            
                            if (parseInt(trn.amount)<0) totalAmount-=parseInt(trn.amount);
                        });
                        for (var i=0; i<5; i++) myseries[i] = totalAmount/100*myseries[i];
                        this.setState({series:myseries});
                        this.setState({totalUseThisMonth:totalUseThisMonth});
                        this.setState({totalPurchaseThisMonth:totalPurchaseThisMonth});
                        this.setState({lastTransaction: transactions[0].description+'('+transactions[0].transactionTime+')'});

                    } else return (<Redirect to="/route/to/redirect" />);
                })
            })                        
    }

    constructor(props) {
        super(props);
        const {translate} = this.props;
        var labels = [translate('trans.SMS'),translate('trans.Campaign'),translate('trans.Transfer'),translate('trans.Expired'),translate('trans.Others')];

        this.state = {
          options: {
            title: {
                text: translate('trans.useUnitsStat'),
                align: 'right'
              },
              subtitle: {
                // text: translate('trans.SMS'),
                // align: 'right'
              },
              legend: {
                position: 'bottom'},
            labels: labels //['SMS', 'Campaign', 'Transfer', 'Expired']
          },
          series: [{
            name: 'series-1',
            data: []
          }]
        }
      }

    render() {
        const { width } = this.props;
        return (
            <div>
                {width === 1 && <AppBarMobile title="Yemot-Admin" />}
                <Stats chart={'perExtension'} />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    version: state.admin.ui.viewVersion,
});

export default 
compose(
    connect(mapStateToProps),
    withDataProvider, withStyles(styles)
)(translate(Statistics)); 